import React from 'react'
import { FormComponent } from '../../../../components/form/DynamicForm'
import { Form, Validators } from '../../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../../Http';
import moment from 'moment';

class PagoFacturasCredito extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'Reporte Pagos Registrados', saveUrl: 'Ventas/save', backUrl: '/Catalogo' },
      new Form([
        Form.Field('select', 'opciones_type', 'Opciones', '1', [Validators.required], 12, [
          { Label: 'Fechas', Value:'1' },
          { Label: 'Rango Folios CYC', Value:'2' },
        ]),
        Form.Field('date', 'start', 'Inicial', '', [Validators.required], 6, []),
        Form.Field('date', 'end', 'Final', '', [Validators.required], 6, []),
      ], ['Descargar Excel'], 'Reporte Pagos Entrega'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  formData = async (form) => {
    let formData = form;
    formData = Form.ValueChange(formData, {
      opciones_type: this.typeChange
    })
    return formData;
  }

  typeChange = async (field) => {
    const { FormData } = this.state;
    let newForm = FormData;
    if (field.Value === '2') {
      Form.FieldMod(newForm, 'start', 'Type', 'text')
      Form.FieldMod(newForm, 'start', 'Value', '0')
      Form.FieldMod(newForm, 'end', 'Type', 'text')
      Form.FieldMod(newForm, 'end', 'Value', '0')
    } else if (field.Value === '1'){
      const fecha = new Date();
      Form.FieldMod(newForm, 'start', 'Type', 'date')
      Form.FieldMod(newForm, 'start', 'Value', fecha)
      Form.FieldMod(newForm, 'end', 'Type', 'date')
      Form.FieldMod(newForm, 'end', 'Value', fecha)
    }
  }

  onSubmit = async (i, vals) => {
    this.setState({ loading: true });
    let { start, end, opciones_type } = vals;
    if (opciones_type === '1') {
      start = moment(start).format('YYYY-MM-DD');
      end = moment(end).format('YYYY-MM-DD');
    }
    const Resp = await Http.get(`transportista/pago-entrega-reporte?q=1&opciones_type=${opciones_type}&start_date=${start}&end_date=${end}`,
      true, 'arraybuffer')
    if (Resp) {
      const blob = new Blob([Resp], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      })
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Reporte_Pagos_Entregas_${start}_${end}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(PagoFacturasCredito)
